{
  " Because it is a one-way hash, your code cannot be reverse-engineered.": " 一方向ハッシュであるため、コードをリバースエンジニアリングすることはできません。",
  " and add this step to your deployment workflow.": " このステップをデプロイメントワークフローに追加します。",
  " proofs and audit ledgers to your designated Shadow Repositories.": " 指定されたシャドウリポジトリへの証明書と監査台帳。",
  " proofs and daily audit ledgers. We require ": " 証明書と日次監査台帳。当社は以下を要求します：",
  " proofs in your Shadow Repository will remain your property.": " シャドウリポジトリ内の証明書はお客様の財産のままです。",
  " receipts and daily audit ledgers to your Shadow Repository.": " 領収書と日次監査台帳をシャドウリポジトリへ。",
  " to this specific repository only.": " この特定のリポジトリのみに。",
  " where we push your cryptographic ": " 当社がお客様の暗号化証明書をプッシュする場所 ",
  " you had an idea, without ever showing us the idea itself.": " アイデアそのものを当社に見せることなく、アイデアがあったこと。",
  "#": "#",
  "(\"we\", \"our\", or \"us\"), privacy and security are the foundational principles of our architecture. We provide a zero-knowledge cryptographic timestamping service designed to prove the existence of your intellectual property without ever requiring access to the intellectual property itself.": "（「当社」「私たち」）、プライバシーとセキュリティは当社アーキテクチャの基本原則です。当社は、知的財産そのものへのアクセスを一切必要とせずに知的財産の存在を証明するよう設計された、ゼロ知識暗号タイムスタンプサービスを提供します。",
  "(c) 2026 RSJ Software GmbH - Germering, Germany": "(c) 2026 RSJ Software GmbH - ドイツ、ゲルメリンク",
  "(c) 2026 RSJ Software GmbH - Germering, Germany - All Intellectual Property Protected via Bitcoin.": "(c) 2026 RSJ Software GmbH - ドイツ、ゲルメリンク - すべての知的財産はビットコインにより保護されています。",
  "(c) 2026 RSJ Software GmbH. All rights reserved.": "(c) 2026 RSJ Software GmbH. 無断転載を禁じます。",
  "+49 89 89 41 42-0": "+49 89 89 41 42-0",
  "+49 89 89 41 42-80": "+49 89 89 41 42-80",
  ". It is a permanent record.": ". これは恒久的な記録です。",
  "/forever": "/永久",
  "/month": "/月",
  "1 Public GitHub Repository": "公開GitHubリポジトリ1件",
  "1,245 Commits": "1,245コミット",
  "1. Acceptance of Terms": "1. 規約の承諾",
  "1. Our Zero-Knowledge Guarantee": "1. ゼロ知識保証について",
  "1. The Source": "1. ソース",
  "10. Contact Information": "10. 連絡先情報",
  "100% internal network execution": "100%内部ネットワークでの実行",
  "2 hours ago": "2時間前",
  "2. Description of Service": "2. サービスの説明",
  "2. Information We Collect": "2. 当社が収集する情報",
  "2. The Monolith Engine": "2. モノリスエンジン",
  "3. How We Use Your Information": "3. お客様の情報の利用方法",
  "3. Intellectual Property": "3. 知的財産",
  "3. The Destination": "3. 宛先",
  "4. Fees and Payment": "4. 料金と支払い",
  "4. How We Share Your Information": "4. お客様の情報の共有方法",
  "412 Commits Sealed": "412コミットを封印",
  "5. Blockchain Specific Provisions": "5. ブロックチェーンに関する特則",
  "5. Data Retention and Deletion": "5. データの保持と削除",
  "6. Prohibited Conduct": "6. 禁止行為",
  "6. Your Data Protection Rights": "6. お客様のデータ保護に関する権利",
  "7. Limitation of Liability": "7. 責任の制限",
  "7. Self-Hosted / Docker Environments": "7. セルフホスト / Docker環境",
  "8. Changes to This Privacy Policy": "8. 本プライバシーポリシーの変更",
  "8. Enterprise Docker License": "8. Enterprise Dockerライセンス",
  "82110 Germering": "82110 ゲルメリンク",
  "9. Contact Us": "9. お問い合わせ",
  "9. Termination": "9. 契約の終了",
  "A 12-line GitHub Action runs on your servers and PUSHES the commit hash to our API.": "12行のGitHub Actionがお客様のサーバーで実行され、コミットハッシュを当社のAPIにプッシュします。",
  "A. Information You Provide to Us": "A. お客様が当社に提供する情報",
  "A. Your Content": "A. お客様のコンテンツ",
  "API Reference": "APIリファレンス",
  "About": "について",
  "Account Data:": "アカウントデータ：",
  "Account Deletion:": "アカウント削除：",
  "Account Information:": "アカウント情報：",
  "Add a cryptographically verifiable badge to your README.": "READMEに暗号的に検証可能なバッジを追加します。",
  "Action": "アクション",
  "Actions": "アクション",
  "Active": "アクティブ",
  "Add Repository": "リポジトリを追加",
  "Add your API key as a repository secret named ": "APIキーを「」という名前のリポジトリシークレットとして追加します ",
  "All commits in this repository are cryptographically timestamped and anchored to the Bitcoin blockchain using ": "このリポジトリ内のすべてのコミットは暗号的にタイムスタンプされ、以下を使用してビットコインブロックチェーンにアンカーされます： ",
  "Analyzing usage trends to optimize our dashboard and Docker images.": "ダッシュボードとDockerイメージを最適化するための利用動向の分析。",
  "Anchored in Block #834102": "ブロック #834102 にアンカー済み",
  "Annually": "年払い",
  "App Name": "アプリ名",
  "Appears on local audit PDF exports.": "ローカル監査PDFエクスポートに表示されます。",
  "Append (Right)": "追加（右）",
  "Applying...": "適用中...",
  "At Timestamp GIT, operated by": "Timestamp GIT（運営：",
  "Attempt to reverse-engineer or disrupt our batching and anchoring engine.": "当社のバッチ処理・アンカリングエンジンのリバースエンジニアリングや妨害を試みること。",
  "Audit Guide": "監査ガイド",
  "B. Data Collected via Our Services": "B. 当社サービスを通じて収集されるデータ",
  "B. Our Service": "B. 当社のサービス",
  "Because you can verify all 42 levels locally, you never need to expose your source code to us.": "42レベルすべてをローカルで検証できるため、ソースコードを当社に公開する必要は一切ありません。",
  "Before detailing standard data collection practices, we want to explicitly state our core security guarantee regarding your source code:": "標準的なデータ収集慣行を詳述する前に、ソースコードに関する当社の中核的なセキュリティ保証を明示します：",
  "Beta": "ベータ",
  "Billing Information:": "請求情報：",
  "Billing:": "請求：",
  "Bitcoin Block Reference": "ビットコインブロック参照",
  "Bitcoin Network": "ビットコインネットワーク",
  "Bitcoin Tx Anchor": "ビットコインTXアンカー",
  "Block #834102": "ブロック #834102",
  "Block #{{block}} confirmed": "ブロック #{{block}} 確認済み",
  "Blockchain Immutability:": "ブロックチェーンの不変性：",
  "Blockchain anchors are permanent. They cannot be deleted or \"undone\".": "ブロックチェーンアンカーは永続的です。削除したり「取り消す」ことはできません。",
  "Blog": "ブログ",
  "Broadcast to Bitcoin Network": "ビットコインネットワークへブロードキャスト",
  "Builds Merkle Tree natively": "マークルツリーをネイティブに構築",
  "By Date (e.g., /2026/03/18/proofs)": "日付別（例：/2026/03/18/proofs）",
  "By Repository (e.g., /frontend-app/2026/proofs)": "リポジトリ別（例：/frontend-app/2026/proofs）",
  "By creating an account or using our services, you confirm that you can form a binding contract with Timestamp GIT and RSJ Software GmbH. If you are using the services on behalf of an organization, you agree to these Terms on behalf of that organization.": "アカウントを作成するか、当社サービスを利用することにより、Timestamp GITおよびRSJ Software GmbHと拘束力のある契約を締結できることを確認します。組織を代表してサービスを利用する場合、その組織を代表して本規約に同意します。",
  "By using this service, you acknowledge and agree to the unique properties of blockchain technology:": "本サービスを利用することで、ブロックチェーン技術の独自の性質を認識し、同意します：",
  "C. Automatically Collected Information": "C. 自動的に収集される情報",
  "Calculatable Verification": "計算可能な検証",
  "Calculate SHA-256": "SHA-256を計算",
  "Calendar Server Node": "カレンダーサーバーノード",
  "Chain of Trust Landmarks": "トラストチェーンのランドマーク",
  "Changes:": "変更：",
  "Choose how you want proofs organized inside your Shadow Repo.": "シャドウリポジトリ内の証明書の整理方法を選択します。",
  "Click \"Verify\" to load the row into the calculator above. Hash it to match the next row.": "「検証」をクリックして、行を上の計算機に読み込みます。ハッシュ化して次の行と一致させます。",
  "Click to verify anchors": "クリックしてアンカーを検証",
  "Commit": "コミット",
  "Commit:": "コミット：",
  "Coming Soon": "近日公開",
  "Company": "会社",
  "Company Information": "会社情報",
  "Compile Python to native and protect your source code.": "Python をネイティブコードにコンパイルし、ソースコードを保護します。",
  "Included free during the Pro beta (until 31 Dec 2026).": "Proベータ期間中は無料で利用できます（2026年12月31日まで）。",
  "More Products": "その他の製品",
  "OpenTimestamps": "OpenTimestamps",
  "OpenTimestamps and Bitcoin make blockchain timestamp verification automatic. This is how to prove code existed at a specific time, without revealing the code.": "OpenTimestampsとBitcoinにより、ブロックチェーン上のタイムスタンプ検証が自動化されます。コードを公開せずに、特定の時点でコードが存在していたことを証明する方法です。",
  "opentimestamps.org": "opentimestamps.org",
  "Pro beta: all Pro features are free until 31 December 2026": "Proベータ版：2026年12月31日まで、すべてのPro機能を無料で利用できます",
  "Py2Native": "Py2Native",
  "Competitors often claim they \"independently developed\" a similar feature. Proving you had the finished logic in your repository 18 months prior creates a mathematical wall they cannot climb.": "競合他社は「独自に開発した」と主張することがよくあります。18か月前に完成したロジックがリポジトリにあったことを証明すれば、彼らが越えられない数学的な壁ができます。",
  "Concept": "コンセプト",
  "Configuration": "設定",
  "Connected Shadow Repository": "接続済みシャドウリポジトリ",
  "Connects to GitHub or GitHub Enterprise Server": "GitHubまたはGitHub Enterprise Serverに接続",
  "Connects to OTS Calendars": "OTSカレンダーに接続",
  "Contact": "連絡先",
  "Contact Sales": "営業に問い合わせ",
  "Convert your demo instance to full Enterprise support.": "デモインスタンスを完全なEnterpriseサポートに変換します。",
  "Cookies and Tracking:": "Cookieとトラッキング：",
  "Copied!": "コピーしました！",
  "Copy Markdown": "Markdownをコピー",
  "Copy Output": "出力をコピー",
  "Copy to clipboard": "クリップボードにコピー",
  "Court-Ready Evidence": "法廷で使える証拠",
  "Coverage": "対象範囲",
  "Created": "作成日時",
  "Credentials or OAuth tokens granting us the explicit, scoped Write Access required to push ": "プッシュに必要な明示的かつスコープ付きの書き込みアクセスを当社に付与する資格情報またはOAuthトークン ",
  "Credit card details and billing address (processed securely via our third-party payment processors like Stripe; we do not store full credit card numbers).": "クレジットカード情報と請求先住所（Stripeなどの第三者決済処理業者により安全に処理されます。当社はクレジットカード番号の完全な形を保存しません）。",
  "Critical IP Risks": "重大なIPリスク",
  "Cryptographic Hashes:": "暗号ハッシュ：",
  "Cryptographic Merkle Root": "暗号マークルルート",
  "Cryptographic prior art": "暗号による先行技術",
  "Current Result (Middle)": "現在の結果（中央）",
  "DOWNLOAD FULL AUDIT LEDGER (CSV)": "完全監査台帳をダウンロード（CSV）",
  "DOWNLOAD PDF CERTIFICATE": "PDF証明書をダウンロード",
  "Daily Bitcoin Batching": "毎日のビットコインバッチ処理",
  "Daily Operations Model": "日次運用モデル",
  "Daily Regularity": "日次定期実行",
  "Date": "日付",
  "Days": "日",
  "Decentralization:": "非中央集権性：",
  "Dedicated Account Manager": "専任アカウントマネージャー",
  "Defend reusable library code from being claimed.": "再利用可能なライブラリコードを主張から守ります。",
  "Demo": "デモ",
  "Depending on your location (e.g., GDPR, CCPA), you may have rights regarding access, rectification, objection, and portability of your personal data.": "お住まいの地域（例：GDPR、CCPA）によっては、個人データへのアクセス、訂正、異議申し立て、および移転に関する権利を有する場合があります。",
  "Deploy Timestamp GIT on your own infrastructure for maximum security and air-gapped environments.": "最大限のセキュリティとエアギャップ環境のために、自社インフラにTimestamp GITをデプロイします。",
  "Deploy the entire Timestamp GIT engine behind your own firewall using our official Docker image. Connects to public GitHub or GitHub Enterprise Server. Perfect for heavily regulated industries.": "公式Dockerイメージを使用して、自社ファイアウォールの内側にTimestamp GITエンジン全体をデプロイします。公開GitHubまたはGitHub Enterprise Serverに接続します。規制の厳しい業界に最適です。",
  "Destination Repository": "宛先リポジトリ",
  "Detailed Coverage Timeline": "詳細な対象期間タイムライン",
  "Dev Shops & Agencies": "開発会社・代理店",
  "Directory Structure": "ディレクトリ構造",
  "Disconnect Shadow Repo": "シャドウリポジトリを切断",
  "Docker Compose Installation": "Docker Composeインストール",
  "Docker Self-Hosted License": "Dockerセルフホストライセンス",
  "Docker Server": "Dockerサーバー",
  "Don't Leave Your IP to Chance": "知的財産を偶然に任せない",
  "Don't use our service to timestamp illegal content or spam.": "違法なコンテンツやスパムのタイムスタンプに当社サービスを使用しないでください。",
  "Download PDF Report": "PDFレポートをダウンロード",
  "Downloadable PDF Audit Reports": "ダウンロード可能なPDF監査レポート",
  "Downloads & Exports": "ダウンロードとエクスポート",
  "E-Mail:": "Eメール：",
  "Each active square represents a day where commits were anchored to Bitcoin.": "アクティブな各マスは、コミットがビットコインにアンカーされた日を表します。",
  "Earliest Anchor": "最古のアンカー",
  "Effective Date: March 18, 2026": "発効日：2026年3月18日",
  "Email": "メール",
  "Embed the Viral Badges": "バイラルバッジを埋め込む",
  "Enterprise": "Enterprise",
  "Enterprise Docker": "Enterprise Docker",
  "Enterprise License Active": "Enterpriseライセンス有効",
  "Enterprise License Applied": "Enterpriseライセンス適用済み",
  "Enterprise ZK": "Enterprise ZK",
  "Enterprise ZK Integration": "Enterprise ZK統合",
  "Easy access to status information via status badges that can be embedded directly in your README.md.": "README.mdに直接埋め込めるステータスバッジによる、ステータス情報への簡単なアクセス。",
  "Everything in Free, plus:": "Freeの全機能に加えて：",
  "Everything in Open Source, plus:": "Open Sourceの全機能に加えて：",
  "Everything in Pro, plus:": "Proの全機能に加えて：",
  "Fax:": "ファックス：",
  "Fees are billed in advance on a monthly or annual basis depending on your plan.": "料金はプランに応じて月次または年次で前払いされます。",
  "Fill out the form below to receive a time-limited demo license for evaluation.": "評価用の期間限定デモライセンスを受け取るには、以下のフォームに記入してください。",
  "First prior-art anchor recorded": "最初の先行技術アンカーを記録",
  "Flat List (Not recommended for large workspaces)": "フラットリスト（大規模なワークスペースには非推奨）",
  "For Enterprise customers utilizing our Self-Hosted Docker deployment:": "セルフホストDockerデプロイメントを利用するEnterpriseのお客様へ：",
  "For customers using our Self-Hosted Docker deployment: The license is limited to the number of instances specified in your Enterprise contract. You are responsible for the security and maintenance of the environment where the Docker container is deployed.": "セルフホストDockerデプロイメントを利用されるお客様へ：ライセンスはEnterprise契約で指定されたインスタンス数に制限されます。Dockerコンテナがデプロイされる環境のセキュリティと保守はお客様の責任です。",
  "For dev shops and startups building proprietary IP.": "独自IPを構築する開発会社やスタートアップ向け。",
  "For open-source projects and public repositories.": "オープンソースプロジェクトと公開リポジトリ向け。",
  "Fork": "フォーク",
  "Former Employee Disputes": "元従業員との紛争",
  "Free": "Free",
  "Freelance Developers": "フリーランス開発者",
  "Full control of Bitcoin anchoring schedules": "ビットコインアンカリングスケジュールの完全な制御",
  "Generate New Key": "新しいキーを生成",
  "Generating Merkle trees and anchoring hashes to the Bitcoin blockchain.": "マークルツリーを生成し、ハッシュをビットコインブロックチェーンにアンカーしています。",
  "Germany": "ドイツ",
  "Get Started": "始める",
  "Get Status Badge": "ステータスバッジを取得",
  "GitHub Action Implementation": "GitHub Action実装",
  "GitHub App": "GitHub App",
  "GitHub App Settings": "GitHub App設定",
  "Go to your GitHub App settings to grant access to repositories.": "GitHub Appの設定でリポジトリへのアクセスを許可してください。",
  "GitHub App reads the ": "GitHub Appが読み取るのは ",
  "Groups all pending hashes": "すべての保留中のハッシュをグループ化",
  "HEAD commit hash of the monitored repository automatically.": "監視対象リポジトリのHEADコミットハッシュを自動的に。",
  "HOW IT WORKS": "仕組み",
  "Hash Queue": "ハッシュキュー",
  "Hash result will appear here...": "ハッシュ結果がここに表示されます...",
  "Here is a quick example of how to initialize the model in your application:": "アプリケーションでモデルを初期化する方法の簡単な例を次に示します：",
  "Holzstrasse 4": "Holzstrasse 4",
  "How we mathematically secure your prior art on the Bitcoin blockchain using a lean, single-container deployment and secure Shadow Repos.": "軽量なシングルコンテナデプロイメントと安全なシャドウリポジトリを使用して、ビットコインブロックチェーン上で先行技術を数学的に保護する仕組み。",
  "IP Protection Badge": "IP保護バッジ",
  "IP addresses, browser types, operating systems, referring URLs, and interaction data.": "IPアドレス、ブラウザの種類、オペレーティングシステム、参照元URL、および操作データ。",
  "If required to do so by law or court order.": "法律または裁判所命令により要求された場合。",
  "If you choose to embed verification badges, basic metadata will be accessible via our public verification endpoints.": "検証バッジを埋め込むことを選択した場合、基本的なメタデータが当社の公開検証エンドポイントからアクセス可能になります。",
  "If you have any questions regarding this Privacy Policy, please contact our Data Protection Officer:": "本プライバシーポリシーに関するご質問がある場合は、当社のデータ保護責任者までお問い合わせください：",
  "Immutability:": "不変性：",
  "Immutable Ledger Active": "不変台帳アクティブ",
  "Implementation": "実装",
  "Important As \"What\"": "「何を」と同様に重要な「いつ」",
  "Impressum": "インプレッサム（サイト運営者情報）",
  "Imprint": "インプリント（運営者情報）",
  "In the modern digital economy, your ideas are your most valuable assets. But without a mathematical timestamp, you don't own them-you're just holding them for someone else.": "現代のデジタル経済において、アイデアは最も貴重な資産です。しかし数学的なタイムスタンプがなければ、それらは自分のものではありません—誰かのために預かっているだけです。",
  "Increase company valuation by proving IP maturity.": "IPの成熟度を証明して企業価値を高めます。",
  "Information according to Sec. 5 TMG (German Telemedia Act). Responsible for content according to Sec. 55 para. 2 RStV: Ruediger Jungbeck.": "ドイツ電気通信メディア法（TMG）第5条に基づく情報。RStV第55条第2項に基づくコンテンツ責任者：Ruediger Jungbeck。",
  "Information you provide when contacting our customer support team.": "カスタマーサポートチームに連絡する際に提供する情報。",
  "Initial Proof (Genesis)": "初期証明（ジェネシス）",
  "Input": "入力",
  "Install GitHub App": "GitHub Appをインストール",
  "Install the Timestamp GIT GitHub App on your repositories to get started.": "開始するには、リポジトリにTimestamp GITのGitHub Appをインストールしてください。",
  "Installation": "インストール",
  "Instance Network Settings": "インスタンスネットワーク設定",
  "Instances only communicate externally with public OpenTimestamps calendar servers and Bitcoin nodes.": "インスタンスは外部とは公開OpenTimestampsカレンダーサーバーとビットコインノードとのみ通信します。",
  "It takes several hours until the transaction is confirmed in the Bitcoin blockchain.": "取引がビットコインブロックチェーンで確認されるまでに数時間かかります。",
  "Integration": "統合",
  "Integrations": "統合",
  "Intellectual Property Notice:": "知的財産に関する通知：",
  "Internal Git Logs": "内部Gitログ",
  "Internal GitHub Enterprise API endpoint.": "内部GitHub Enterprise APIエンドポイント。",
  "Internal Org Name": "内部組織名",
  "Invert": "反転",
  "It takes 60 seconds to connect your first repository. It takes a lifetime to recover from a stolen idea.": "最初のリポジトリの接続には60秒しかかかりません。盗まれたアイデアからの回復には一生かかります。",
  "Iterate:": "反復：",
  "Jan 15, 2026": "2026年1月15日",
  "Key Name": "キー名",
  "Last": "最後",
  "Last Anchored": "最終アンカー日時",
  "Last Successful Anchor": "最後に成功したアンカー",
  "Last Updated: March 18, 2026": "最終更新日：2026年3月18日",
  "Last Used": "最終使用日時",
  "Latest Anchor": "最新のアンカー",
  "Latest Anchor Verification Data": "最新アンカー検証データ",
  "Ledger": "台帳",
  "Let your users know this project is cryptographically timestamped. Copy the Markdown below and paste it at the top of your ": "このプロジェクトが暗号的にタイムスタンプされていることをユーザーに知らせましょう。以下のMarkdownをコピーして、お使いの ",
  "Legal Department:": "法務部：",
  "Legal Notice": "法的通知",
  "Legal Prior Art Verified": "法的先行技術を検証済み",
  "Legal Proof:": "法的証明：",
  "Legal Registry": "法務レジストリ",
  "Legal Representative": "法定代理人",
  "Legal Requirements:": "法的要件：",
  "Legal Whitepaper": "法務ホワイトペーパー",
  "License Management": "ライセンス管理",
  "Limited feature set. Please upload a license file to unlock.": "機能は制限されています。ロックを解除するにはライセンスファイルをアップロードしてください。",
  "Live Preview": "ライブプレビュー",
  "Loaded": "読み込み済み",
  "Loading repositories...": "リポジトリを読み込み中...",
  "Local GitHub URL": "ローカルGitHub URL",
  "Log and Usage Data:": "ログと利用データ：",
  "Login": "ログイン",
  "Logout": "ログアウト",
  "Manage your shadow repositories, tracked projects, and API keys.": "シャドウリポジトリ、追跡中のプロジェクト、APIキーを管理します。",
  "Management": "管理",
  "Managing Director:": "代表取締役：",
  "Manipulatable": "改ざん可能",
  "Matched": "一致",
  "Mathematical proof of your intellectual property doesn't have to be expensive. Protect your codebase for less than a cup of coffee.": "知的財産の数学的証明は高価である必要はありません。コーヒー1杯分以下の費用でコードベースを保護できます。",
  "Mathematically Absolute": "数学的に絶対",
  "Mathematically Guaranteed": "数学的に保証",
  "Mathematically prove milestone completion times.": "マイルストーン完了時期を数学的に証明します。",
  "Maximum security and zero codebase access for paranoid teams.": "最大限のセキュリティとコードベースへのゼロアクセス。セキュリティにこだわるチーム向け。",
  "Menu": "メニュー",
  "Merkle Roots containing the mathematical representation of your hashes are broadcast to the Bitcoin blockchain. ": "ハッシュの数学的表現を含むマークルルートがビットコインブロックチェーンにブロードキャストされます。 ",
  "Midnight Cron Worker": "深夜のCronワーカー",
  "Monitored Repos": "監視中リポジトリ",
  "Monthly": "月払い",
  "Months": "か月",
  "Most Popular": "最も人気",
  "Multiple Agency Clients": "複数の代理店クライアント",
  "Name": "名前",
  "Name of the application as displayed in the UI": "UIに表示されるアプリケーション名",
  "Name, email address, company name, and password when you register for an account.": "アカウント登録時の名前、メールアドレス、会社名、パスワード。",
  "No Abuse:": "悪用の禁止：",
  "No commits anchored": "アンカーされたコミットはありません",
  "No external API calls to our servers": "当社サーバーへの外部API呼び出しなし",
  "No repositories found": "リポジトリが見つかりません",
  "No repositories selected": "リポジトリが選択されていません",
  "Non-practicing entities (trolls) often file broad patents on \"obvious\" technologies. If you implemented that tech months before their filing but have no proof, you face ruinous litigation.": "非実施主体（パテントトロール）は「明白な」技術に対して広範な特許を出願することがよくあります。出願の数か月前にその技術を実装していても証明がなければ、破滅的な訴訟に直面します。",
  "Note on Service Nature:": "サービス性質に関する注記：",
  "Oct 12, 2025": "2025年10月12日",
  "On-Premises Instance": "オンプレミスインスタンス",
  "Once a Merkle Root is anchored to the Bitcoin blockchain, it is permanent. We cannot modify, hide, or delete these records.": "マークルルートがビットコインブロックチェーンにアンカーされると、それは永続的です。当社はこれらの記録を変更、隠蔽、削除することはできません。",
  "Once anchored, a hash ": "一度アンカーされると、ハッシュは ",
  "Open Source": "オープンソース",
  "Operator": "運営者",
  "Optional contact number": "任意の連絡先電話番号",
  "Organization Info": "組織情報",
  "Once a day, we start an OpenTimestamps stamp for all pending hashes.": "1日1回、すべての保留中のハッシュに対してOpenTimestampsスタンプを開始します。",
  "Once confirmed, we write the timestamp into your repository and show it in your status badge.": "確認後、タイムスタンプをリポジトリに書き込み、ステータスバッジに表示します。",
  "Our bot directly pushes the cryptographic proofs to the client's repository.": "当社のボットが暗号証明書をクライアントのリポジトリに直接プッシュします。",
  "Our service relies on the Bitcoin network. We are not responsible for delays caused by network congestion or protocol changes in the underlying blockchain.": "当社サービスはビットコインネットワークに依存しています。ネットワークの輻輳や基盤となるブロックチェーンのプロトコル変更による遅延について、当社は責任を負いません。",
  "Output": "出力",
  "Paste concatenated hex string here (Left + Middle + Right)...": "連結された16進文字列をここに貼り付けます（左 + 中央 + 右）...",
  "Patent Troll Defense": "パテントトロール対策",
  "Paused": "一時停止中",
  "Pending Bitcoin Block": "保留中のビットコインブロック",
  "Perfect for solo developers and public open-source projects.": "個人開発者や公開オープンソースプロジェクトに最適です。",
  "Phone": "電話",
  "Phone:": "電話：",
  "Prefix": "プレフィックス",
  "Prepend (Left)": "前置（左）",
  "Pricing": "料金",
  "Prior Art": "先行技術",
  "Prior Art Proofs": "先行技術の証明",
  "Priority Mempool Anchoring": "優先メンプールアンカリング",
  "Privacy Policy": "プライバシーポリシー",
  "Private": "非公開",
  "Private Repositories": "非公開リポジトリ",
  "Private Shadow Repos": "非公開シャドウリポジトリ",
  "Private Shadow Repositories": "非公開シャドウリポジトリ",
  "Pro Agency": "Pro Agency",
  "Pro Tip": "プロのヒント",
  "Problem": "課題",
  "Processing payments and providing customer support.": "支払い処理とカスタマーサポートの提供。",
  "Professional \"Certificate of Authorship\" handoffs.": "プロフェッショナルな「著作者証明書」の引き渡し。",
  "Proof": "証明",
  "Proof Longevity": "証明の長期有効性",
  "Proofs": "証明書",
  "Protect trade secrets without filing public docs.": "公開書類を提出せずに営業秘密を保護します。",
  "Protect your intellectual property from patent trolls and IP theft with globally recognized cryptographic standards.": "世界的に認知された暗号標準で、パテントトロールやIP窃盗から知的財産を保護します。",
  "Protected": "保護済み",
  "Prove work-delivery dates during payment disputes.": "支払い紛争時に業務納品日を証明します。",
  "Public": "公開",
  "Public Badges:": "公開バッジ：",
  "Public Base URL": "公開ベースURL",
  "Public Shields.io Badge": "公開Shields.ioバッジ",
  "Pushing ": "プッシュ中： ",
  "Questions about the Terms of Service should be sent to:": "利用規約に関する質問は次の宛先に送信してください：",
  "Quick Start": "クイックスタート",
  "RSJ Software GmbH": "RSJ Software GmbH",
  "Read-Only Access": "読み取り専用アクセス",
  "Ready: {{file}}": "準備完了：{{file}}",
  "Recreating the GitHub App will invalidate all existing app installations. All users who previously installed the app will need to re-install it, and all timestamp data linked to the old app will be orphaned. Only proceed if you are absolutely certain.": "GitHub Appを再作成すると、既存のアプリインストールはすべて無効になります。以前アプリをインストールしたすべてのユーザーは再インストールする必要があり、古いアプリにリンクされたすべてのタイムスタンプデータは孤立します。絶対に確信がある場合のみ進めてください。",
  "Refunds:": "返金：",
  "Registered to RSJ Software GmbH": "RSJ Software GmbHに登録",
  "Registry & Tax": "登記と税務",
  "Replace File": "ファイルを置き換え",
  "Repositories currently being tracked automatically via the GitHub App.": "現在GitHub App経由で自動追跡中のリポジトリ。",
  "Repositories unavailable": "リポジトリを利用できません",
  "Repository": "リポジトリ",
  "Repository Connected!": "リポジトリ接続完了！",
  "Repository Metadata:": "リポジトリメタデータ：",
  "Repository names, commit timestamps, and standard Git author metadata.": "リポジトリ名、コミットのタイムスタンプ、標準的なGit著者メタデータ。",
  "Request Docker License": "Dockerライセンスをリクエスト",
  "Request Submitted": "リクエスト送信済み",
  "Request a Demo License": "デモライセンスをリクエスト",
  "Required for GitHub Webhook callbacks.": "GitHub Webhookコールバックに必要です。",
  "Resources": "リソース",
  "Resume": "再開",
  "Retained as long as your account is active or needed to comply with legal obligations.": "アカウントがアクティブである間、または法的義務を遵守するために必要な限り保持されます。",
  "Reverse Byte Order (Little-Endian / Big-Endian)": "バイト順を反転（リトルエンディアン / ビッグエンディアン）",
  "Revoke": "失効",
  "Row 1 \"Current Result\" is your local Git commit hash.": "行1「現在の結果」はローカルのGitコミットハッシュです。",
  "Ruediger Jungbeck": "Ruediger Jungbeck",
  "Running GitHub Enterprise Server or GitLab Self-Managed? Deploy the entire Timestamp GIT engine behind your own firewall using our official Docker image. Perfect for heavily regulated industries.": "GitHub Enterprise ServerまたはGitLab Self-Managedを運用中ですか？公式Dockerイメージを使用して、自社ファイアウォールの内側にTimestamp GITエンジン全体をデプロイできます。規制の厳しい業界に最適です。",
  "Sample Integration": "サンプル統合",
  "Save 20%": "20%節約",
  "Save Configuration": "設定を保存",
  "Search repositories...": "リポジトリを検索...",
  "Secure \"Prior Art\" before a patent filing.": "特許出願の前に「先行技術」を保護します。",
  "Secure Your Prior Art": "先行技術を保護する",
  "Secure portfolio pieces against plagiarism.": "ポートフォリオ作品を剽窃から守ります。",
  "Security Protocol": "セキュリティプロトコル",
  "Select a repository to view its timestamp verification status and proof history.": "リポジトリを選択して、タイムスタンプ検証ステータスと証明履歴を表示します。",
  "Self-Hosted / Air-Gapped": "セルフホスト / エアギャップ",
  "Sending service updates and security alerts.": "サービス更新情報とセキュリティアラートの送信。",
  "Service Providers:": "サービスプロバイダー：",
  "Settings Applied": "設定を適用しました",
  "Severing connections to GitHub and deleting personal metadata from our active databases.": "GitHubへの接続を切断し、アクティブなデータベースから個人メタデータを削除します。",
  "Shadow Repo": "シャドウリポジトリ",
  "Shadow Repository Configuration:": "シャドウリポジトリ設定：",
  "Shield the agency from liability if clients are sued.": "クライアントが訴えられた場合に代理店を責任から守ります。",
  "Show the world your intellectual property is protected. Copy the Markdown below and paste it at the top of your ": "知的財産が保護されていることを世界に示しましょう。以下のMarkdownをコピーして、お使いの ",
  "Show your users this project is protected": "ユーザーにこのプロジェクトが保護されていることを示す",
  "Simple, Transparent Pricing": "シンプルで透明な料金",
  "Since blockchain anchoring incurs immediate, irreversible computational and transaction costs, we generally do not offer refunds once hashes have been anchored.": "ブロックチェーンアンカリングは即時的で不可逆的な計算コストと取引コストを伴うため、ハッシュがアンカーされた後の返金は原則として行っておりません。",
  "Software development moves at light speed, creating three critical legal and strategic blindspots.": "ソフトウェア開発は光速で進み、3つの重大な法的・戦略的盲点を生み出します。",
  "Standard Git history is stored on servers you do not own (GitHub) or databases you can edit (Local). In a serious legal audit, internal logs are often dismissed as \"self-serving\" or \"manipulatable.\"": "標準的なGit履歴は、お客様が所有しないサーバー（GitHub）や編集可能なデータベース（ローカル）に保存されます。厳格な法務監査では、内部ログはしばしば「自己都合」または「改ざん可能」として退けられます。",
  "Standard Mode": "標準モード",
  "Standard Mode Repositories": "標準モードのリポジトリ",
  "Standard cookies to maintain user sessions and analyze site traffic.": "ユーザーセッションの維持とサイトトラフィック分析のための標準Cookie。",
  "Status Badge": "ステータスバッジ",
  "Status Badges": "ステータスバッジ",
  "Star": "スター",
  "Start Securing Prior Art": "先行技術の保護を始める",
  "Start for Free": "無料で開始",
  "Start:": "開始：",
  "Startups & Founders": "スタートアップと創業者",
  "Status": "ステータス",
  "Stop Tracking": "追跡を停止",
  "Store": "保存",
  "Submit Request": "リクエストを送信",
  "Super Awesome AI": "Super Awesome AI",
  "Support Data:": "サポートデータ：",
  "System Online": "システム稼働中",
  "TO THE MAXIMUM EXTENT PERMITTED BY LAW, RSJ SOFTWARE GMBH SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOSS OF PROFITS OR DATA. OUR TOTAL LIABILITY FOR ANY CLAIM SHALL NOT EXCEED THE TOTAL FEES PAID BY YOU IN THE 12 MONTHS PRIOR TO THE CLAIM.": "法律で認められる最大限の範囲で、RSJ SOFTWARE GMBHは、逸失利益やデータ損失を含む、間接的、付随的、特別、または結果的損害について一切責任を負いません。当社のあらゆる請求に対する総責任額は、請求前12か月間に支払われた総費用を超えないものとします。",
  "Target Git Commit": "対象Gitコミット",
  "Tax ID: 117/136/80100": "税番号：117/136/80100",
  "Terms at a Glance": "規約の概要",
  "Terms of Service": "利用規約",
  "Thank you for your interest. We will review your request and send a demo license file to your email address within one business day.": "ご関心をお寄せいただきありがとうございます。リクエストを確認し、1営業日以内にデモライセンスファイルをメールアドレスに送信します。",
  "The \"Clean Room\" Fallacy": "「クリーンルーム」の誤謬",
  "The Anchor": "アンカー",
  "The Bitcoin Blockchain:": "ビットコインブロックチェーン：",
  "The Fingerprint": "フィンガープリント",
  "The Fragility of Logs": "ログの脆弱性",
  "The OpenTimestamps protocol anchors the Merkle root of the daily batch into a Bitcoin block.": "OpenTimestampsプロトコルが、日次バッチのマークルルートをビットコインブロックにアンカーします。",
  "The Patent Troll Threat": "パテントトロールの脅威",
  "The Proof": "証明",
  "The Proof of Existence Gap": "存在証明のギャップ",
  "The SHA-256 (or similar) hashes of your Git commits.": "GitコミットのSHA-256（または同等）ハッシュ。",
  "The Timestamp GIT dashboard, API, and Docker images are the intellectual property of RSJ Software GmbH. You are granted a non-exclusive, non-transferable license to use these services according to your subscription tier.": "Timestamp GITのダッシュボード、API、DockerイメージはRSJ Software GmbHの知的財産です。お客様には、サブスクリプションティアに応じてこれらのサービスを利用する非独占的かつ譲渡不可のライセンスが付与されます。",
  "The Vulnerability of \"New\"": "「新しい」ことの脆弱性",
  "The requested Docker license is a time-limited demo license for evaluation purposes.": "リクエストされたDockerライセンスは、評価目的の期間限定デモライセンスです。",
  "The application will be available at http://localhost:8080 after startup. On first launch, follow the setup wizard to connect your GitHub App and configure your instance.": "起動後、アプリケーションはhttp://localhost:8080で利用可能になります。初回起動時は、セットアップウィザードに従ってGitHub Appを接続し、インスタンスを設定してください。",
  "The cryptographic proof relies entirely on Bitcoin math. You can verify it locally even if our company disappears.": "暗号証明は完全にビットコインの数学に依存しています。当社が消滅しても、ローカルで検証できます。",
  "The full mathematical path mapping your commit to Bitcoin. Concatenate strings, hash via SHA-256, and pass the result down.": "コミットをビットコインにマッピングする完全な数学的パス。文字列を連結し、SHA-256でハッシュ化して、結果を渡します。",
  "This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our SaaS platform, interact with our GitHub App, or utilize our Enterprise Docker containers (collectively, the \"Services\").": "本プライバシーポリシーは、当社のウェブサイトを訪問し、SaaSプラットフォームを利用し、GitHub Appと連携し、またはEnterprise Dockerコンテナを利用する際（総称して「サービス」）に、当社がどのように情報を収集、使用、開示、保護するかを説明します。",
  "This data is public and immutable.": "このデータは公開されており、不変です。",
  "This is the ": "これは ",
  "This project provides next-generation machine learning tools for edge devices.": "このプロジェクトは、エッジデバイス向けの次世代機械学習ツールを提供します。",
  "This provides mathematically undeniable proof of prior art and authorship for all code and ideas contained within.": "これは、含まれるすべてのコードとアイデアについて、先行技術と著作者性の数学的に否定できない証明を提供します。",
  "This public ledger provides mathematically undeniable evidence of the repository's existence over time.": "この公開台帳は、時間の経過にわたるリポジトリの存在について、数学的に否定できない証拠を提供します。",
  "Timestamp Branch / Private Shadow Repo": "タイムスタンプブランチ / 非公開シャドウリポジトリ",
  "Timestamp GIT": "Timestamp GIT",
  "Timestamp GIT Enterprise is distributed as a Docker image. Use the following Docker Compose configuration to get started:": "Timestamp GIT EnterpriseはDockerイメージとして配布されます。開始するには、次のDocker Compose設定を使用します：",
  "Timestamp GIT provides a technical service. The eventual \"legal weight\" of the evidence provided depends on the jurisdiction and the specific requirements of the court or authority. We provide the math; you provide the context.": "Timestamp GITは技術的サービスを提供します。提供される証拠の最終的な「法的効力」は、管轄区域および裁判所や当局の具体的な要件に依存します。当社は数学を提供し、お客様は文脈を提供します。",
  "Timestamp GIT provides cryptographic proof-of-existence for digital files and Git commits. Our service calculates hashes, aggregates them into Merkle trees, and anchors the resulting Merkle Root into the Bitcoin blockchain via the OpenTimestamps protocol.": "Timestamp GITは、デジタルファイルとGitコミットの暗号による存在証明を提供します。当社のサービスはハッシュを計算し、マークルツリーに集約し、結果のマークルルートをOpenTimestampsプロトコル経由でビットコインブロックチェーンにアンカーします。",
  "Timestamp any content that is illegal, defamatory, or violates third-party IP rights.": "違法、名誉毀損的、または第三者のIP権利を侵害するコンテンツにタイムスタンプを付けないでください。",
  "To Communicate:": "連絡のため：",
  "To Deliver Proofs:": "証明書の提供のため：",
  "To Improve Our Platform:": "プラットフォーム改善のため：",
  "To Manage Your Account:": "アカウント管理のため：",
  "To Provide the Service:": "サービス提供のため：",
  "Today, 00:05 UTC": "今日、00:05 UTC",
  "Toggle color scheme": "配色を切り替え",
  "Top Merkle Root": "最上位マークルルート",
  "Total Proofs": "証明書の総数",
  "Trade Register: Munich HRB 76084": "商業登記：ミュンヘン HRB 76084",
  "Traditional IP protection is broken. It is either too expensive (Patents) or too weak (Internal Logs). Timestamp GIT creates a new mathematical middle ground.": "従来のIP保護は機能していません。高すぎる（特許）か、弱すぎる（内部ログ）かのどちらかです。Timestamp GITは新しい数学的な中間点を生み出します。",
  "Transaction Hash": "トランザクションハッシュ",
  "Transparency:": "透明性：",
  "Timestamp recorded": "タイムスタンプ記録済み",
  "Trial Mode Active": "トライアルモード有効",
  "Trust Math, Not Servers": "サーバーではなく数学を信頼する",
  "Trusted third-party vendors (e.g., AWS, Stripe).": "信頼できる第三者ベンダー（例：AWS、Stripe）。",
  "Unlimited Private Repositories": "無制限の非公開リポジトリ",
  "Unlimited Public Repositories": "無制限の公開リポジトリ",
  "Unlimited Repositories": "無制限のリポジトリ",
  "Update README.md with Timestamp GIT badges": "README.mdをTimestamp GITバッジで更新",
  "Upload .lic file": ".licファイルをアップロード",
  "Usage": "利用状況",
  "Use the API or GitHub Action in a way that causes excessive load or \"spamming\" of the Bitcoin mempool.": "ビットコインメンプールに過度の負荷や「スパム」を引き起こす方法でAPIまたはGitHub Actionを使用すること。",
  "Use these API keys in your CI/CD pipelines (GitHub Actions, GitLab CI, Jenkins) to push commit hashes securely.": "これらのAPIキーをCI/CDパイプライン（GitHub Actions、GitLab CI、Jenkins）で使用して、コミットハッシュを安全にプッシュします。",
  "VAT-ID: DE 128 239 592": "付加価値税番号：DE 128 239 592",
  "VERIFY MATHEMATICS": "数学を検証する",
  "VIEW MATHEMATICAL PATH": "数学的パスを表示",
  "VS": "VS",
  "ValKey": "ValKey",
  "Vendor Independent": "ベンダー非依存",
  "Verification": "検証",
  "Verification is powered by the OpenTimestamps protocol anchored into the Bitcoin Blockchain.": "検証は、ビットコインブロックチェーンにアンカーされたOpenTimestampsプロトコルによって実現されます。",
  "Verify": "検証",
  "Version": "バージョン",
  "Version:": "バージョン：",
  "View in GitHub": "GitHubで表示",
  "Viral Badges": "バイラルバッジ",
  "Warning: Recreating the GitHub App": "警告：GitHub Appの再作成",
  "Watch": "ウォッチ",
  "We are beta-testing the Pro Agency plan, so the Free plan currently includes every Pro feature at no cost. When the beta ends on 31 December 2026, the Free plan returns to its standard feature set and the Pro limits are enforced again.": "現在Pro Agencyプランをベータテスト中のため、FreeプランではすべてのPro機能を追加費用なしで利用できます。ベータ終了後の2026年12月31日以降、Freeプランは標準の機能セットに戻り、Proプランの制限が再び適用されます。",
  "We are now actively tracking ": "現在、以下をアクティブに追跡しています： ",
  "We could not load your repositories at the moment.": "現在、リポジトリを読み込めませんでした。",
  "We do not collect telemetry or hashes from your internal instances.": "内部インスタンスからテレメトリやハッシュを収集することはありません。",
  "We do not read, copy, store, or transmit your actual source code.": "実際のソースコードを読み取り、コピー、保存、送信することはありません。",
  "We do not sell your personal information. We may share your information only in the following specific circumstances:": "当社は個人情報を販売しません。以下の特定の状況でのみ情報を共有する場合があります：",
  "We extract only the hash and cryptographically embed it into a Bitcoin transaction, freezing its existence in time.": "当社はハッシュのみを抽出し、それをビットコイン取引に暗号的に埋め込み、その存在を時間の中で凍結します。",
  "We may suspend or terminate your account if you violate these Terms. Upon termination, your access to the dashboard and API will cease. Existing ": "本規約に違反した場合、当社はアカウントを停止または終了することがあります。終了後、ダッシュボードとAPIへのアクセスは停止されます。既存の ",
  "We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on this page.": "当社は本プライバシーポリシーを随時更新する場合があります。重要な変更については、このページに更新後のポリシーを掲載してお知らせします。",
  "We never see, copy, or store your actual source code. We only mathematically stamp the public Git hash.": "実際のソースコードを見ることも、コピーすることも、保存することもありません。公開Gitハッシュに数学的にスタンプを付けるだけです。",
  "We provide mathematical evidence, not legal representation.": "当社は数学的証拠を提供します。法的代理ではありません。",
  "We turn your everyday Git commits into irrefutable legal evidence. Prove exactly ": "日常のGitコミットを反論の余地のない法的証拠に変えます。正確に証明します： ",
  "We use the collected information for the following purposes:": "収集した情報を以下の目的で使用します：",
  "Web:": "ウェブ：",
  "Webhooks": "Webhooks",
  "Welcome to Timestamp GIT. These Terms of Service (\"Terms\") govern your access to and use of our platform, APIs, GitHub App, and Docker containers. By using Timestamp GIT, you agree to be bound by these Terms.": "Timestamp GITへようこそ。本利用規約（「規約」）は、当社のプラットフォーム、API、GitHub App、Dockerコンテナへのアクセスと利用を規定します。Timestamp GITを利用することで、本規約に拘束されることに同意します。",
  "Welcome to the official repository for": "公式リポジトリへようこそ：",
  "What's included": "含まれるもの",
  "When a lead developer leaves, disputes often arise over when a specific feature or algorithm was conceived. Without an immutable timestamp, it becomes a \"he-said, she-said\" battle in court.": "主任開発者が退職すると、特定の機能やアルゴリズムがいつ考案されたかをめぐって紛争が生じることがよくあります。不変のタイムスタンプがなければ、法廷で「言った、言わない」の争いになります。",
  "When users click these badges on your GitHub page, they will be redirected to your public cryptographic verification ledger, proving your undeniable prior art ownership.": "ユーザーがGitHubページでこれらのバッジをクリックすると、公開暗号検証台帳にリダイレクトされ、否定できない先行技術の所有権が証明されます。",
  "When you commit code, Git generates a unique, one-way hash representing the exact state of your entire repository.": "コードをコミットすると、Gitはリポジトリ全体の正確な状態を表す一意の一方向ハッシュを生成します。",
  "Whether you use our Standard Mode (GitHub App) or Enterprise ZK Mode (GitHub Actions/Docker), our systems only extract, receive, and process cryptographic hashes (e.g., SHA-256) of your Git commits.": "標準モード（GitHub App）またはEnterprise ZKモード（GitHub Actions/Docker）のどちらを使用しても、当社のシステムはGitコミットの暗号ハッシュ（例：SHA-256）のみを抽出、受信、処理します。",
  "While commit hashes are opaque, the fact that a specific hash was anchored at a specific time is a public record.": "コミットハッシュは不透明ですが、特定のハッシュが特定の時刻にアンカーされたという事実は公開記録です。",
  "While we do not collect your source code, we do collect standard business and metadata necessary to provide and secure our Services:": "当社はソースコードを収集しませんが、サービスを提供し保護するために必要な標準的なビジネスデータとメタデータを収集します：",
  "Who is this for?": "誰のためのものですか？",
  "Why Proving \"When\" Is Just As": "「いつ」の証明が「何を」と同様に重要な理由",
  "Without Exposing Code": "コードを公開せずに",
  "Workspace Configuration": "ワークスペース設定",
  "Write Access": "書き込みアクセス",
  "Years": "年",
  "You agree not to use the Service to:": "お客様は、本サービスを以下の目的に使用しないことに同意します：",
  "You can install the package via pip:": "pipでパッケージをインストールできます：",
  "You can upgrade or downgrade your plan at any time. Downgrades take effect at the end of the current billing cycle.": "プランはいつでもアップグレードまたはダウングレードできます。ダウングレードは現在の請求サイクルの終了時に有効になります。",
  "You own your code. We never read it; we only see the hashes.": "コードはお客様のものです。当社はそれを読むことはなく、ハッシュを見るだけです。",
  "You receive an immutable `.ots` receipt. You can now mathematically prove to any lawyer, auditor, or court that your idea existed on this date.": "不変の`.ots`領収書を受け取ります。これで、弁護士、監査人、裁判所のいずれに対しても、この日にアイデアが存在したことを数学的に証明できます。",
  "You retain all ownership rights to your source code and data. Timestamp GIT does not claim any license or ownership over the content you timestamp.": "ソースコードとデータに対するすべての所有権はお客様に留保されます。Timestamp GITは、お客様がタイムスタンプしたコンテンツに対するライセンスや所有権を主張しません。",
  "Your Code:": "お客様のコード：",
  "Your Repositories": "お客様のリポジトリ",
  "ZK Timestamp URL": "ZKタイムスタンプURL",
  "Generate the authenticated POST URL that your CI/CD pipeline can use to timestamp commits without exposing your source code.": "ソースコードを公開せずにCI/CDパイプラインがコミットにタイムスタンプを付けるために使用できる、認証済みのPOST URLを生成します。",
  "Owner": "所有者",
  "Target Repository": "ターゲットリポジトリ",
  "Generate URL": "URLを生成",
  "POST URL": "POST URL",
  "Append the commit SHA to this URL to timestamp a commit.": "このURLにコミットSHAを追加すると、コミットにタイムスタンプが付けられます。",
  "Example:": "例：",
  "Repository and target repository are required.": "リポジトリとターゲットリポジトリが必要です。",
  "This feature requires a ZK or Admin subscription.": "この機能にはZKまたはAdminサブスクリプションが必要です。",
  "The Zero-Knowledge commit API is available with ZK and Admin subscriptions.": "Zero-KnowledgeコミットAPIは、ZKおよびAdminサブスクリプションで利用できます。",
  "View Pricing": "料金を見る",
  "Your subscription does not allow generating this URL.": "このURLを生成するには、お客様のサブスクリプションでは許可されていません。",
  "Could not generate the URL. Please try again.": "URLを生成できませんでした。もう一度お試しください。",
  "Copied": "コピーしました",
  "Copy URL": "URLをコピー",
  "Your cryptographic proofs are embedded in the Bitcoin blockchain.": "暗号証明はビットコインのブロックチェーンに埋め込まれています。",
  "Your company or organization": "お客様の会社または組織",
  "Your first cryptographic anchor is pending in the daily batch.": "最初の暗号アンカーが日次バッチで保留中です。",
  "Your full name": "フルネーム",
  "Zero Code Access": "コードへのアクセスゼロ",
  "Zero Knowledge Architecture": "ゼロ知識アーキテクチャ",
  "Zero-Knowledge API Keys": "ゼロ知識APIキー",
  "Zero-Knowledge GitHub Action": "ゼロ知識GitHub Action",
  "Zero-Knowledge Pipeline": "ゼロ知識パイプライン",
  "Zero-Knowledge Security": "ゼロ知識セキュリティ",
  "Zero-Knowledge Timestamp Architecture": "ゼロ知識タイムスタンプアーキテクチャ",
  "Zero-Knowledge: We never read code. We only mathematically stamp the hash.": "ゼロ知識：コードを読むことは決してありません。ハッシュに数学的にスタンプを付けるだけです。",
  "aiohttp": "aiohttp",
  "cannot be deleted, modified, or removed": "削除、変更、削除することはできません",
  "file.": "ファイル。",
  "is your primary shield to invalidate these claims.": "は、これらの主張を無効化するための主要な盾です。",
  "isolated, private GitHub repository": "隔離された非公開GitHubリポジトリ",
  "when": "いつ"
}
